import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../components/modal";
import * as Yup from "yup";
import { FormInput } from "../../wrappers/formInput";
import Button from "../../components/button";
import FormHead from "../../components/headings/FromHead"
import { DropDownInput } from "../../wrappers/selectInput";
import Datepicker from "../../components/datepicker";
import Styles from './styles.module.scss'
import { getMilliSecUTC } from "../../utils/EllowUtils";
import { Error } from "@progress/kendo-react-labels";

export type RefereePaymentForm = {
  paymentAmount: number;
  paymentCurrency: string;
  paymentDate: number;
}

interface Props {
  onClose?: any;
  ClickHandler?: any;
  defaultValues?: any;
}

const validationSchema = Yup.object({
  paymentAmount: Yup.string().required("Field is Required"),
  paymentCurrency: Yup.string().required("Field is Required")
})

const RefereePayment: React.FC<Props> = ({ onClose, ClickHandler, defaultValues }) => {

  const formOptions = { resolver: yupResolver(validationSchema)}

  const { register, handleSubmit, control, setValue, formState } = useForm<RefereePaymentForm>(formOptions);

  const [errors, setErrors] = useState<{ paymentDate?: string}>({ paymentDate: ""});

  const onSubmit = (data: any) => {
    
    if(data.paymentDate) {
      let body = {
        "paymentAmount": parseInt(data.paymentAmount),
        "paymentCurrency": data.paymentCurrency,
        "paymentDate": getMilliSecUTC(data.paymentDate)
  
      }
      ClickHandler(body);
    }else{
      errors.paymentDate =  'Field is required'
    }
  }

  const changeOn = (event: any, type: string) => {
    if (type === 'paymentDate') {
      setValue('paymentDate', event.value)
      delete errors.paymentDate
      setErrors({...errors})
    }
  }

  return (
    <div>
      <Modal title={"Referee payment"} size="medium" onClose={onClose}>
        <form>
          <FormHead>Referee Payment</FormHead>
          <div className="half-form-wrap">
            <div className="form-group">
              <FormInput<RefereePaymentForm >
                name="paymentAmount"
                register={register}
                errors={formState.errors}
                label="Payment Amount*"
                placeholder="Enter Amount"
              />
            </div>
              <div className={Styles.paymentCurrency}>
              <DropDownInput<RefereePaymentForm>
                name="paymentCurrency"
                register={register}
                errors={formState.errors}
                control={control}
                data={['INR', 'USD']}
                />
            </div>
            <div className="form-group">
            <label className="lablel">Payment Done on*</label>
              <Datepicker
                defaultShow={false}
                onChange={(e: any) => changeOn(e, 'paymentDate')}
              />
              <Error>{errors?.paymentDate}</Error>
            </div>
          </div>
          <div className="popupAction">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSubmit(onSubmit)}>
              Save
            </Button>
          </div>
        </form>
      </Modal>
    </div>
  )
}

export default  RefereePayment;
